@use "~@nwi/style-core/variables/color" as *;

@use "styles/themes" as *;

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  align-self: center;
}

:host {
  display: block;
  font-size: 16px;
  font-family: Calibri, sans-serif;
  justify-content: center;
  align-items: center;

  .variants-dropdown-wrapper {
    margin-bottom: 10px;
    user-select: none;

    .variants-dropdown {
      position: absolute;
      width: 25%;
      top: 0;
      left: 0;
      z-index: 10;
      padding: 20px 40px;

      .dropdown-head {
        display: flex;
        justify-content: space-between;
        padding: 10px;
        border-bottom: solid black 1px;
        cursor: pointer;
        background: white;

        img {
          width: 15px;
          transition: transform 0.3s ease-in;

          &.open {
            transform: rotate(180deg);
          }
        }
      }

      .options-container {
        z-index: 4;
        width: 100%;
        background-color: $white;
        border-top: none;
        max-height: 0;
        transition: max-height 0.6s;
        overflow: hidden;

        &.open {
          max-height: 500px;
        }

        .option {
          padding: 6px 3px 6px;
          border-bottom: solid black 1px;
          cursor: pointer;

          &:hover {
            background-color: #d9d9d9;
          }
        }
      }
    }
  }

  .content {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 20px 40px;
    display: flex;
    flex-direction: row;
  }

  .exterior-selection-wrapper,
  .wheel-selection-wrapper {
    display: flex;
  }

  .exterior-selection,
  .wheel-selection {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    flex: 1 0 auto;
    overflow: visible;
    scroll-behavior: smooth;
    margin-bottom: 0;
    padding: 4px;
    transition: transform 0.6s ease-in-out;
    gap: 10px 5px;
  }

  .wheel-container,
  .exterior-container {
    position: relative;
    padding: 2px;

    &:hover {
      cursor: pointer;
    }
  }

  .exterior,
  .wheel {
    z-index: 2;
    display: block;
    border-radius: 100%;
  }

  .checkmark {
    position: absolute;
  }

  .selection-container {
    border-radius: 42px;
    background: white;
    align-self: center;
    padding: 4px;
    position: relative;
    width: 84px;
    transition: width 0.6s ease-in-out;

    &.selected {
      width: 445px;
      height: fit-content;
      border-radius: 40px;
      overflow: hidden;

      .nav-prev {
        left: 0;
      }

      .nav-next {
        right: 0;
      }
    }

    .nav-prev,
    .nav-next {
      z-index: 20;
      position: absolute;
      width: 0;
      background: white;
      border-radius: 50%;
      justify-content: center;
      cursor: pointer;
      display: flex;
      visibility: hidden;
      opacity: 0;

      &.open {
        transition: opacity 0.3s ease-in-out;
        visibility: visible;
        opacity: 1;
        width: 74px;
        height: 74px;
      }
    }

    .edit-icon {
      position: absolute;
      z-index: 50;
      background: white;
      border-radius: 100%;
      width: 25px;
      bottom: 10%;
      right: 15%;
      opacity: 1;
      transition: opacity 0.1s ease-in-out 0.5s;

      &.hidden {
        opacity: 0;
        transition: none;
      }
    }
  }

  .cta-section {
    position: absolute;
    display: flex;
    flex-direction: column;
    bottom: 0;
    padding: 20px 40px;
    right: 0;

    .cta-wrapper {
      display: flex;
      flex-direction: column;
      row-gap: 10px;

      button {
        padding: 1em;
        color: white;
        white-space: nowrap;
        background-color: #222;
        border: none;
        transition: 0.3s ease;
        align-self: flex-end;

        &:hover {
          background-color: #444;
          cursor: pointer;
        }
      }
    }
  }

  #nwi-root {
    &.XS {
      .variants-dropdown {
        position: relative;
      }

      .content {
        position: relative;
        column-gap: 5px;
        background: $grey-medium;
        padding: 10px 10px;
      }
    }

    &.SM {
      .variants-dropdown {
        position: absolute;
      }

      .content {
        position: absolute;
        bottom: 70px;
        left: 50%;
        transform: translate(-50%, 0);
        background: unset;
        padding: 20px 30px;
        column-gap: 5px;
      }
    }

    &.XS,
    &.SM {
      .cta-section {
        position: relative;
      }

      .variants-dropdown {
        width: 260px;
        padding: 20px 30px;
      }

      .selection-container {
        width: 64px;

        &.selected {
          border-radius: 32px;
          width: 274px;

          .nav-prev,
          .nav-next {
            width: 54px;
            height: 54px;
          }
        }
      }

      .exterior,
      .wheel {
        width: 42px;
        height: 42px;
      }
    }

    &.MD {
      .variants-dropdown {
        position: absolute;
        width: 260px;
        padding: 20px 40px;
      }

      .content {
        bottom: 0;
        left: 0;
        transform: none;
        padding: 20px 40px;
        column-gap: 10px;
      }

      .cta-section {
        position: absolute;
      }

      .exterior,
      .wheel {
        width: 52px;
        height: 52px;
      }

      .selection-container {
        width: 74px;

        &.selected {
          width: 385px;
          border-radius: 37px;

          .nav-prev,
          .nav-next {
            width: 64px;
            height: 64px;
          }
        }
      }
    }

    &.LG,
    &.XL,
    &.XXL,
    &.XXXL {
      .content {
        bottom: 0;
        left: 0;
        transform: none;
        padding: 20px 40px;
        column-gap: 20px;
      }

      .cta-section {
        position: absolute;
      }
      .variants-dropdown {
        position: absolute;
        width: 25%;
        padding: 20px 40px;
      }

      .exterior,
      .wheel {
        width: 62px;
        height: 62px;
      }

      .selection-container {
        width: 84px;

        &.selected {
          width: 445px;
          border-radius: 42px;

          .nav-prev,
          .nav-next {
            width: 74px;
            height: 74px;
          }
        }
      }
    }

    &:not(.MD) {
      .variants-dropdown-wrapper {
        display: flex;
        justify-content: center;
      }
    }
  }
}
